import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled(Layout)`
    min-height: '60vh';
    position: 'relative';
    justify-content: 'space-between';
`;
